export function plural(base: string, qty: number, options?: { prefixQty: boolean }) {
  const text = qty > 1 ? `${base}s` : base;
  return options?.prefixQty ? `${qty} ${text}` : text;
}

export function replacePlural(qty: number, singular: string, plural: string, options?: { prefixQty: boolean }): string {
  const text = qty > 1 ? plural : singular;
  return options?.prefixQty ? `${qty} ${text}` : text;
}
